import React from "react";

import { Grid, Typography } from "@mui/material";

interface DisplayErrorProps {
  // The error message, pass in your desired error message directly here.
  errorMessage: string;
  align?: "inherit" | "left" | "right" | "center" | "justify";
}

const DisplayError = ({ errorMessage, align }: DisplayErrorProps) => {
  if (errorMessage) {
    return (
      <Grid container spacing={1} data-testid="validation-error-displayed">
        <Grid item xs={12}>
          <Typography align={align ?? "center"} color="error">
            {errorMessage}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  return null;
};

export default DisplayError;
